import { defaultRegion } from "common/config";
import { atom } from "jotai";

export const filtersOpenAtom = atom<boolean>(false);
export const mapVisibleOnMobileAtom = atom<boolean>(true);
export const leftPanelExpandedAtom = atom<boolean>(true);

export const mobileListViewAtom = atom<boolean>(true);

// Tracks where the mobile venue detail was opened from (list or map), so the
// back action can return the user to the same view. Shared by the search page
// and the What's Nearby map.
export const mapDetailOriginAtom = atom<"list" | "map">("list");

export const venueDetailsOpenedAtom = atom<boolean>(false);
export const searchVenueAtom = atom<string>("");
export const searchTermInputAtom = atom<string>("");
export const mapCenterAtom = atom({
  lat: defaultRegion.latitude,
  lng: defaultRegion.longitude,
});

// Live map viewport (centre + NE/SW bounds), kept in sync by BasicMapView so the
// venue-list map-mode toggle can search the current viewport without a map ref.
export type MapViewport = {
  lat: number;
  lng: number;
  ne: { lat: number; lng: number };
  sw: { lat: number; lng: number };
  zoom: number;
} | null;
export const mapViewportAtom = atom(null as MapViewport);
export const savedPlaceIdToViewAtom = atom<string>("");
export const savedPlaceByUserIdToViewAtom = atom<string>("");
export const savedPlaceSortByToViewAtom = atom<string>("");
export const savedPlaceIdToViewDataChangedAtom = atom<boolean>(false);
export const hoveredVenueIdAtom = atom<string>("");
export const viewModeAtom = atom<"mapper" | "user">("mapper");
export const searchOverlayOpenAtom = atom<boolean>(false);
export const activeSavedSearchIdAtom = atom(null as string | number | null);

// Google place_id selected on the home page (no map). BasicMapView reads it on
// mount and dispatches selectGooglePlace. Empty string = nothing pending.
export const pendingGooglePlaceIdAtom = atom<string>("");

// Bumped when a deliberate area/category search is dispatched from the search bar.
export const fitMapToResultsAtom = atom<number>(0);

// Venue picked from auto-suggest, hoisted to the top of the results list. Tied to
// the recenter it triggers (lat/lng + empty search) so any other search unpins it.
export type PinnedFirstVenue = { id: string; lat: string; lng: string } | null;
export const pinnedFirstVenueAtom = atom(null as PinnedFirstVenue);

// Reference marker for a selected location/area/landmark suggestion with no
// venue of its own (e.g. "Tottenham Court Road"). Null = none shown.
export type LocationSearchAnchor = { lat: number; lng: number; label: string } | null;
export const locationSearchAnchorAtom = atom(null as LocationSearchAnchor);

// JSON-serialised compound search from the home page. Empty string = nothing pending.
export const pendingCompoundSearchAtom = atom<string>("");

// Bridges desktop home "view all" actions to /search with real results, avoiding
// an empty/incomplete flash during the route transition + initial data fetch.
export const isSearchNavigationLoadingAtom = atom<boolean>(false);
